<template>
  <div class="XVfilter">
    <fieldset>
      <slot name="content"></slot>
      <div class="row">
        <div class="col-md-12">
          <div class="XVSearchbar">
            <div class="XVSearchbarButtongroup btn-group">
              <slot name="filterbuttons">

              </slot>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>

export default {
  name: 'XVfilter',
  props: ['id'] 
  
}
</script>
